import DOMPurify from 'dompurify';

/**
 * Simple, secure markdown to HTML renderer for AI insights debriefs.
 */
export const renderMarkdown = (text: string): string => {
    if (!text) return '';
    let html = text;
    // Bold
    html = html.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    // Italics
    html = html.replace(/\*(.*?)\*/g, '<em>$1</em>');
    // Headings
    html = html.replace(/^#### (.*$)/gim, '<h4 class="text-base font-semibold text-cyan-200 mt-3 mb-1">$1</h4>');
    html = html.replace(/^### (.*$)/gim, '<h3 class="text-lg font-semibold text-cyan-400 mt-4 mb-2">$1</h3>');
    html = html.replace(/^## (.*$)/gim, '<h2 class="text-xl font-bold text-cyan-300 mt-5 mb-2">$1</h2>');
    html = html.replace(/^# (.*$)/gim, '<h1 class="text-2xl font-bold text-cyan-200 mt-6 mb-3">$1</h1>');
    // Horizontal rules
    html = html.replace(/^---$/gim, '<hr class="border-gray-700 my-3" />');
    // Lists
    html = html.replace(/^\s*[-*] (.*$)/gim, '<li class="ml-4">$1</li>');
    html = html.replace(/<\/li>\s*<li/g, '</li><li'); // Fix spacing between list items
    html = html.replace(/(<li.*<\/li>)/gs, '<ul class="list-disc list-inside space-y-1 my-2">$1</ul>');
    // Paragraphs (simple version)
    html = html.split('\n').map(p => p.trim() ? `<p>${p}</p>` : '').join('').replace(/<\/p><p>/g, '</p><p class="mt-2">');
    return DOMPurify.sanitize(html);
};
